import { Handshake } from 'lucide-react';
import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ComingSoon } from '../../components/admin/ui';

export function CRMDealsPage() {
  return (
    <AdminLayout
      title="Deals"
      description="Suivez votre pipeline commercial et vos opportunités"
    >
      <ComingSoon
        icon={Handshake}
        title="Pipeline Commercial"
        description="Visualisez et pilotez votre pipeline de vente du premier contact à la signature."
        features={[
          'Vue Kanban du pipeline par étapes',
          'Prévisions de revenus et probabilités',
          'Automatisation des workflows commerciaux',
          'Suivi des tâches et rappels',
          'Rapports de performance commerciale',
        ]}
      />
    </AdminLayout>
  );
}
